"use client";
import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import MerchantFaqsAccordion from "./MerchantFaqsAccordionProps";
import { Faqs } from "@/services/dataTypes";

const INITIAL_COUNT = 6;

interface Props {
    faqs: Faqs[];
}

const FaqsWithShowMore = ({ faqs }: Props) => {
    const [showAll, setShowAll] = useState(false);

    const visible = showAll ? faqs : faqs.slice(0, INITIAL_COUNT);
    const hasMore = faqs.length > INITIAL_COUNT;

    return (
        <>
            <div className="faq-wrapper mt-3">
                <Accordion defaultActiveKey="0">
                    {visible.map((faq, idx) => (
                        <MerchantFaqsAccordion key={idx} faq={faq} index={idx} />
                    ))}
                </Accordion>
            </div>

            {hasMore && (
                <div className="t2-faq-toggle-wrap">
                    <button
                        className="t2-faq-toggle-btn"
                        onClick={() => setShowAll((prev) => !prev)}
                        aria-expanded={showAll}
                    >
                        {showAll ? (
                            <>
                                <span>Show Less</span>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="18 15 12 9 6 15" />
                                </svg>
                            </>
                        ) : (
                            <>
                                <span>Show {faqs.length - INITIAL_COUNT} More</span>
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                    <polyline points="6 9 12 15 18 9" />
                                </svg>
                            </>
                        )}
                    </button>
                </div>
            )}
        </>
    );
};

export default FaqsWithShowMore;
